import i18n from "../i18n";import api from "./api";
import { normalizeApiMediaUrl } from "./constant";

let cachedCourses = null;
let coursesRequest = null;

function clearCourseCache() {
  cachedCourses = null;
  coursesRequest = null;
}

export function normalizeCourse(course) {
  if (!course) return course;
  return {
    ...course,
    certificateTemplate: course.certificateTemplate
      ? {
          ...course.certificateTemplate,
          templateUrl: normalizeApiMediaUrl(course.certificateTemplate.templateUrl || course.certificateTemplate.backgroundUrl)
        }
      : course.certificateTemplate,
    p_link: normalizeApiMediaUrl(course.p_link),
    y_link: normalizeApiMediaUrl(course.y_link),
    mediaUrl: normalizeApiMediaUrl(course.mediaUrl),
	    syllabusUrl: normalizeApiMediaUrl(course.syllabusUrl),
	    tieUpCertificateUrl: normalizeApiMediaUrl(course.tieUpCertificateUrl),
	    bookUrl: normalizeApiMediaUrl(course.bookUrl),
	    pptUrl: normalizeApiMediaUrl(course.pptUrl),
	    quizQaUrl: normalizeApiMediaUrl(course.quizQaUrl),
    image: normalizeApiMediaUrl(course.image),
    thumbnail: normalizeApiMediaUrl(course.thumbnail),
  };
}

export function isLearnerVisibleCourse(course) {
  if (!course) return false;
  const status = String(course.status || "").toUpperCase();
  if (status === "REJECTED") return false;
  if (course.hidden === true || course.isHidden === true || course.courseHidden === true) return false;
  return !status || status === "APPROVED";
}

export function isCoursePaymentEnabled(course) {
  if (!course) return true;
  return course.paymentEnabled !== false && course.isPaymentEnabled !== false;
}

const normalizeCourses = (courses) => (
  Array.isArray(courses)
    ? courses.map(normalizeCourse).filter(isLearnerVisibleCourse)
    : courses
);

async function getAllCourses() {
  if (cachedCourses) {
    return { success: true, data: cachedCourses };
  }
  if (coursesRequest) {
    return coursesRequest;
  }
  coursesRequest = (async () => {
  try {
    const { data } = await api.get("/api/courses");
    const normalized = normalizeCourses(data);
    cachedCourses = normalized;
    return { success: true, data: normalized };
  } catch (error) {
    console.error("Error fetching courses:", error);
    return { success: false, error: i18n.t("Could not fetch courses") };
  } finally {
    coursesRequest = null;
  }
  })();
  return coursesRequest;
}

async function searchCourses(query) {
  try {
    const { data } = await api.get(`/api/courses?query=${encodeURIComponent(query)}`);
    // Keep matching consistent when the public courses endpoint ignores the optional query.
    const normalizedQuery = String(query || "").trim().toLowerCase();
    const courses = normalizeCourses(data);
    return { success: true, data: (Array.isArray(courses) ? courses : []).filter(course =>
      `${course.course_name || ""} ${course.branch?.name || ""}`.toLowerCase().includes(normalizedQuery)
    ) };
  } catch (error) {
    return { success: false, error: i18n.t("Could not search courses") };
  }
}

async function getCourseById(courseId) {
  try {
    const { data } = await api.get(`/api/courses/${courseId}`);
    return { success: true, data: normalizeCourse(data) };
  } catch (error) {
    console.error("Error fetching course:", error);
    return { success: false, error: i18n.t("Could not fetch course details") };
  }
}

async function getFeedbacks(courseId) {
  try {
    const { data } = await api.get(`/api/feedbacks/${courseId}`);
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching feedbacks:", error);
    return { success: false, error: i18n.t("Unable to fetch feedbacks") };
  }
}

async function postFeedback(courseId, comment) {
  try {
    await api.post("/api/feedbacks", { comment, course_id: courseId });
    return { success: true };
  } catch (error) {
    console.error("Error posting feedback:", error);
    return { success: false, error: i18n.t("Unable to post feedback") };
  }
}

async function getMessages(courseId) {
  try {
    const { data } = await api.get(`/api/discussions/${courseId}`);
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching messages:", error);
    return { success: false, error: i18n.t("Unable to fetch messages") };
  }
}

async function addMessage(formData) {
  try {
    const { data } = await api.post("/api/discussions/addMessage", formData);
    return { success: true, data };
  } catch (error) {
    console.error("Error adding message:", error);
    return { success: false, error: i18n.t("Unable to add message") };
  }
}

async function generateCertificate(courseId) {
  try {
    const { data } = await api.post(`/api/certificates/courses/${courseId}/generate`);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.response?.data?.message || "Could not generate certificate" };
  }
}

async function getCertificateStatus(courseId) {
  try {
    const { data } = await api.get(`/api/certificates/courses/${courseId}/status`);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.response?.data?.message || "Could not fetch certificate status" };
  }
}

async function getMyCertificates() {
  try {
    const { data } = await api.get("/api/certificates/my");
    return { success: true, data };
  } catch (error) {
    return { success: false, error: i18n.t("Could not fetch certificates") };
  }
}

export const courseService = {
  clearCourseCache,
  isLearnerVisibleCourse,
  isCoursePaymentEnabled,
  getAllCourses,
  searchCourses,
  getCourseById,
  getFeedbacks,
  postFeedback,
  getMessages,
  addMessage,
  getCertificateStatus,
  generateCertificate,
  getMyCertificates
};
